var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6702 12.4H13.0382L14.0582 6.60357H15.6903L14.6702 12.4ZM11.6653 6.60357L10.1095 10.5904L9.92539 9.73188L9.92555 9.73219L9.37643 7.12547C9.37643 7.12547 9.31003 6.60357 8.60228 6.60357H6.03018L6 6.70172C6 6.70172 6.78655 6.85305 7.70708 7.36425L9.12492 12.4001H10.8253L13.4217 6.60357H11.6653ZM24.5015 12.4H26L24.6935 6.60342H23.3816C22.7758 6.60342 22.6283 7.03539 22.6283 7.03539L20.1943 12.4H21.8955L22.2357 11.539H24.3104L24.5015 12.4ZM22.7057 10.3496L23.5632 8.18044L24.0456 10.3496H22.7057ZM20.3219 7.99748L20.5548 6.75273C20.5548 6.75273 19.8362 6.5 19.087 6.5C18.2772 6.5 16.354 6.82731 16.354 8.41891C16.354 9.91639 18.6112 9.93499 18.6112 10.7216C18.6112 11.5081 16.5865 11.3672 15.9183 10.8712L15.6757 12.1727C15.6757 12.1727 16.4044 12.5 17.5178 12.5C18.6315 12.5 20.3115 11.9668 20.3115 10.5155C20.3115 9.00841 18.034 8.86809 18.034 8.21285C18.0342 7.55745 19.6236 7.64164 20.3219 7.99748Z",
    fill: "#2566AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5L9.44046 7.00045C9.44046 7.00045 9.3728 6.5 8.65163 6.5H6.03075L6 6.59411C6 6.59411 7.2597 6.82129 8.46797 7.67246C9.62327 8.48602 10 9.5 10 9.5Z",
    fill: "#E6A540"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 18,
    rx: 1.5,
    stroke: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.ac2016910b1e0e95ffb6b6dad5235ef6.svg";
export { ForwardRef as ReactComponent };